import React from "react";
import Carousel from "../components/Carousel";
// import About from "./About";
import Shop from "./Shop";
import ShopDetails from "./ShopDetails";

function Home() {
  const images = [
    "https://images.unsplash.com/photo-1581079289196-67865ea83118?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80",
    "https://images.unsplash.com/photo-1617353121798-30de9bc74806?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
    "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80",
  ];
  return (
    <div>
      <Carousel images={images} />
      {/* <About /> */}
      <Shop />
      <ShopDetails />
    </div>
  );
}

export default Home;
